import request from '@/router/axios'
import env from '@/config/env'

// 获取分页
export const pageApi = (params) => {
  return request({
    url: env.ferryUrl + '/service-phone/page',
    method: 'POST',
    data: params
  })
}
// 更新排序接口
export const updateSort = (params) => {
  return request({
    url: env.ferryUrl + '/service-phone/update-sort',
    method: 'post',
    data: params
  })
}
// 修改状态接口
export const changeStatus = (params) => {
  return request({
    url: env.ferryUrl + `/service-phone/change-status/${params.id}/${params.status}`,
    method: 'get'
  })
}
// 详情
export const servicePhoneInfo = (id) => {
  return request({
    url: env.ferryUrl + `/service-phone/info/${id}`,
    method: 'get'
  })
}
// 保存或更新接口
export const servicePhoneSave = (params) => {
  return request({
    url: env.ferryUrl + '/service-phone/save-update',
    method: 'post',
    data: params
  })
}
